import * as R from 'ramda'
import React, { useCallback } from 'react'
import styled from 'styled-components'

import { CtaBtn } from '../containers/Button'
import CardWrapper from '../containers/CardWrapper'
import { useTranslation } from '../i18n'
import { getColor, getFontSize } from '../utils/cssUtils'
import { Field, TextInput } from './Form'
import Flex from './Layout/Flex'

const Wrapper = styled(CardWrapper)`
  width: 100%;
  padding: 32px 24px;
`
const CustomAmt = styled.div`
  margin-top: 12px;
`
const Reminder = styled.div`
  color: ${getColor('lightGrey')};
  margin-top: 8px;
  font-size: ${getFontSize('body1')};
  line-height: 1.67;
  text-align: right;
`
const Title = styled.span`
  display: inline-flex;
  font-size: ${getFontSize('title')};
  font-weight: 600;
  line-height: 1.4;
  margin-bottom: 20px;
  span {
    margin-right: 5px;
  }
`
const Description = styled.p`
  text-align: justify;
  font-size: ${getFontSize('body2')};
  line-height: 1.87;
  letter-spacing: 1.07px;
  margin-bottom: 16px;
`
const DonorCount = styled.span`
  font-size: ${getFontSize('headline')};
  font-weight: 600;
`
const DonorCountText = styled.span`
  font-size: ${getFontSize('body1')};
  color: ${getColor('black')};
  font-weight: normal;
`
const MinAmount = styled.div``

const DonationItem = React.memo(
  ({
    className,
    allowCustomAmount,
    customAmount,
    donationCount,
    title,
    amount,
    minAmount,
    description,
    partnerEventId,
    disabled,
    onPress,
    onJoinDonationEvent,
    onCustomAmountUpdated
  }) => {
    const { t } = useTranslation('common')
    const handleCustomAmtInput = useCallback(e => {
      const value = R.isEmpty(e.target.value)
        ? ''
        : parseInt(e.target.value, 10)
      onCustomAmountUpdated(value)
    }, [])
    return (
      <Wrapper showHoverEffect className={className}>
        <Title>
          {!allowCustomAmount && !partnerEventId && (
            <span>
              {t('common.currency')}
              {amount / 100}
            </span>
          )}
          <span>{title}</span>
        </Title>
        {allowCustomAmount && (
          <>
            <CustomAmt>
              <Field>
                <TextInput
                  prefix='HKD'
                  type='number'
                  inputMode='numeric'
                  value={customAmount}
                  min={10}
                  max={50000}
                  onChange={handleCustomAmtInput}
                  onPressEnter={onPress}
                  placeholder={t('donationItem.pleaseInputAmount')}
                  disabled={disabled}
                />
              </Field>
            </CustomAmt>
            <Reminder>{t('donationItem.reminder')}</Reminder>
          </>
        )}
        {minAmount && (
          <MinAmount>
            {t('donationItem.minAmount', {
              minAmount: minAmount / 100
            })}
          </MinAmount>
        )}
        <Description dangerouslySetInnerHTML={{ __html: description }} />
        <Flex justify='space-between' align='flex-end'>
          {partnerEventId ? (
            <CtaBtn disabled={disabled} onClick={onJoinDonationEvent}>
              {t('donationItem.eventJoinNow')}
            </CtaBtn>
          ) : (
            <CtaBtn disabled={disabled} onClick={onPress}>
              {t('donationItem.donate')}
            </CtaBtn>
          )}
          <DonorCount>
            {donationCount || 0}
            <DonorCountText>
              {partnerEventId
                ? t('donationItem.eventDonationCount')
                : t('donationItem.donationCount')}
            </DonorCountText>
          </DonorCount>
        </Flex>
      </Wrapper>
    )
  }
)

export default DonationItem
